<template>
  <AggregateSalesDashboard
    title="年間作業予定 売上情報"
    eyebrow="Scheduled Work Sales"
    description="年度内の年間予定作業を、建物・顧客・業者・業務区分・担当者・月別で横断比較できます。上部で傾向を掴み、下部の表で詳細を確認する運用に最適化しています。"
    :tabs="tabs"
    :theme="theme"
  />
</template>

<script>
import AggregateSalesDashboard from '@/components/aggregate/AggregateSalesDashboard.vue';
import {
  getAggregateSalesByBuilding,
  getAggregateSalesByBusinessClassification,
  getAggregateSalesByCustomer,
  getAggregateSalesByInCharge,
  getAggregateSalesByMonth,
  getAggregateSalesByVendor,
} from '@/api/axios';
import { createAggregateTabs } from '@/utils/aggregateDashboard';

const tabs = createAggregateTabs({
  buildingFetcher: getAggregateSalesByBuilding,
  customerFetcher: getAggregateSalesByCustomer,
  vendorFetcher: getAggregateSalesByVendor,
  businessFetcher: getAggregateSalesByBusinessClassification,
  inChargeFetcher: getAggregateSalesByInCharge,
  monthFetcher: getAggregateSalesByMonth,
});

const theme = {
  accent: '#1f6fb2',
  accentSoft: '#dceeff',
  accentStrong: '#154c78',
  accentRgb: '31, 111, 178',
  surfaceAlt: '#f5faff',
  border: '#d6e5f2',
  textMuted: '#60758b',
};

export default {
  name: 'SalesByData',
  components: {
    AggregateSalesDashboard,
  },
  setup() {
    return {
      tabs,
      theme,
    };
  },
};
</script>
